import React from 'react';
import { useLocation } from 'wouter';

import FhfChildForm from './fhfForm/ChildForm';

import type { Child } from '../../common/types/child';

type Props = {
  child: Child;
  updateChild: (child: Child) => void;
  saveChild: (child: Child) => void;
};

const reactAppVersion = process.env.REACT_APP_VERSION;

function ChildForm(props: Props) {
  const [location] = useLocation();

  if (reactAppVersion === 'dnd') {
    return <></>;
  }
  if (reactAppVersion === 'fb') {
    return <></>;
  }
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return <></>;
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return <></>;
  }
  if (reactAppVersion === 'fhf') {
    return <FhfChildForm child={props.child} updateChild={props.updateChild} saveChild={props.saveChild} />;
  }
  return <></>;
}

export default ChildForm;
